<header class="main-header">
  <!-- Logo -->
  <a href="" class="logo">
    <!-- mini logo for sidebar mini 50x50 pixels -->
    <span class="logo-mini"><b>S</b>MO</span>
    <!-- logo for regular state and mobile devices -->
    <img src="./assets/images/logo-branco.svg" class="logo-image" alt="User Image">
  </a>
  <!-- Header Navbar: style can be found in header.less -->
  <nav class="navbar navbar-static-top">
    <!-- Sidebar toggle button-->
    <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
      <i class="fas fa-bars"></i>
    </a>

    <div class="navbar-custom-menu">
      <ul class="nav navbar-nav">
        <li class="dropdown tasks-menu">
          <!-- Menu Toggle Button -->
          <a href="javascript:void(0)" class="dropdown-toggle"
            (click)="abrirAcompanhamentos();$event.stopPropagation();">
            <i class="fas fa-stethoscope"></i>
            <span class="label label-danger">{{ acompanhamentosAtivos }}</span>
          </a>
        </li>


        <li class="dropdown tasks-menu">
          <!-- Menu Toggle Button -->
          <a href="javascript:void(0)" class="dropdown-toggle"
            (click)="abrirAgendamentos();$event.stopPropagation();">
            <i class="fa fa-calendar-plus"></i>
            <span class="label label-danger">{{ agendamentosHoje }}</span>
          </a>
        </li>

        <li class="dropdown user user-menu" style="cursor: pointer">
          <!-- Menu Toggle Button -->
          <a [href]="" (click)="pacienteDetalhe.abrir();$event.stopPropagation();" class="-toggle" data-toggle=""
            data-izimodal-open="#modal_mudar_estabelecimento">
            <!-- The user image in the navbar-->
            <img src="./assets/images/user.png" class="user-image">
            <!-- hidden-xs hides the username on small devices so only the image appears. -->

            <span class="hidden-xs">{{ pacienteAtual ? (pacienteAtual.nome + " / " + pacienteAtual.cpf) : 'Paciente não
              selecionado.' }}</span>
          </a>
        </li>

        <!-- Control Sidebar Toggle Button -->
        <li>
          <a href="#" data-toggle="control-sidebar" (click)='sair()'>
            <i class="fa fa-sign-out-alt"></i></a>
        </li>

      </ul>
    </div>
  </nav>
</header>


<app-paciente-detalhe #pacienteDetalhe>
</app-paciente-detalhe>

